export const INTELLECTUAL_PROPERTY_CATALOG_PATH =
  "/danh-muc-tai-san-tri-tue";
export const INTELLECTUAL_PROPERTY_CATALOG_SOURCE =
  "danh-muc-tai-san-tri-tue";
export const INTELLECTUAL_PROPERTY_CATALOG_TITLE =
  "Danh m\u1ee5c T\u00e0i s\u1ea3n tr\u00ed tu\u1ec7";
export const DOCUMENT_MANAGER_PATH = "/quan-ly-ho-so";
export const DOCUMENT_MANAGER_SOURCE = "quan-ly-ho-so";
export const DOCUMENT_MANAGER_TITLE = "Danh s\u00e1ch h\u1ed3 s\u01a1";

export const buildIntellectualPropertyCatalogState = (overrides = {}) => ({
  source: INTELLECTUAL_PROPERTY_CATALOG_SOURCE,
  activeSidebarPath: INTELLECTUAL_PROPERTY_CATALOG_PATH,
  backTo: INTELLECTUAL_PROPERTY_CATALOG_PATH,
  headerTitle: INTELLECTUAL_PROPERTY_CATALOG_TITLE,
  ...overrides,
});

export const withIntellectualPropertyCatalogSearch = (path) => {
  const separator = path.includes("?") ? "&" : "?";
  return `${path}${separator}from=${INTELLECTUAL_PROPERTY_CATALOG_SOURCE}`;
};

export const buildDocumentManagerState = (overrides = {}) => ({
  source: DOCUMENT_MANAGER_SOURCE,
  activeSidebarPath: DOCUMENT_MANAGER_PATH,
  backTo: DOCUMENT_MANAGER_PATH,
  headerTitle: DOCUMENT_MANAGER_TITLE,
  ...overrides,
});

export const withDocumentManagerSearch = (path) => {
  const separator = path.includes("?") ? "&" : "?";
  return `${path}${separator}from=${DOCUMENT_MANAGER_SOURCE}`;
};

export const isIntellectualPropertyCatalogContext = (location) => {
  const searchParams = new URLSearchParams(location?.search || "");
  const source = searchParams.get("from");

  return (
    source === INTELLECTUAL_PROPERTY_CATALOG_SOURCE ||
    location?.state?.source === INTELLECTUAL_PROPERTY_CATALOG_SOURCE ||
    location?.state?.activeSidebarPath === INTELLECTUAL_PROPERTY_CATALOG_PATH
  );
};

export const isDocumentManagerContext = (location) => {
  const searchParams = new URLSearchParams(location?.search || "");
  const source = searchParams.get("from");

  return (
    source === DOCUMENT_MANAGER_SOURCE ||
    location?.state?.source === DOCUMENT_MANAGER_SOURCE ||
    location?.state?.activeSidebarPath === DOCUMENT_MANAGER_PATH
  );
};

export const getActiveSidebarPathOverride = (location) => {
  if (isIntellectualPropertyCatalogContext(location)) {
    return INTELLECTUAL_PROPERTY_CATALOG_PATH;
  }

  if (isDocumentManagerContext(location)) {
    return DOCUMENT_MANAGER_PATH;
  }

  return location?.state?.activeSidebarPath || "";
};

export const getHeaderTitleOverride = (location) => {
  if (isIntellectualPropertyCatalogContext(location)) {
    return location?.state?.headerTitle || INTELLECTUAL_PROPERTY_CATALOG_TITLE;
  }

  if (isDocumentManagerContext(location)) {
    return location?.state?.headerTitle || DOCUMENT_MANAGER_TITLE;
  }

  return location?.state?.headerTitle || "";
};

export const getIntellectualPropertyCatalogBackPath = (location) => {
  if (!isIntellectualPropertyCatalogContext(location)) return "";

  return location?.state?.backTo || INTELLECTUAL_PROPERTY_CATALOG_PATH;
};

export const getDocumentManagerBackPath = (location) => {
  if (!isDocumentManagerContext(location)) return "";

  return location?.state?.backTo || DOCUMENT_MANAGER_PATH;
};
